import { Component, Input, Inject } from '@angular/core';
import moment from 'moment';

export const imageByType = {
    '2': 'redCircle',
    '1': 'orangeCircle',
    '0': 'greenCircle '
};

@Component({
    selector: 'activity-item',
    template: require('./activity-item.component.html'),
    styles: [require('./activity-item.component.scss')]
})
export class ActivityItemComponent {
    @Input() public item: any;

    constructor(@Inject('processDetailsModalService') private processDetailsModalService: any) {
    }

    public getImage(type: any) {
        return `dbm-${imageByType[type]}`;
    }

    public convertUTCtoLocal(date: any) {
        if (!date) {
            return '';
        }
        const stillUtc = moment.utc(date, 'DD/MM/YYYY HH:mm:ss').toDate();
        const local = moment(stillUtc).local().toDate();
        return local.toLocaleString();
    }

    public showActivityDetails() {
        if (this.item.jobQId != null) {
            const activityIcon = this.getImage(this.item.type);
            this.processDetailsModalService.OpenProcessDetailsModal({ activityIcon, JobQId: this.item.jobQId }, true);
        }
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/authorized/environmentDetails/environment-activities/activity-item/activity-item.component.ts